/**
 * Import required libraries
 */
import React, { useState, useRef } from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
import UsersRender from "./render";

/**
 * Users Component
 */
function Users(props) {
  const [menuIsOpen, openMenu] = useState(false);

  function clickProfile(event) {
    openMenu(!menuIsOpen);
  }

  function handleClose(event) {
    openMenu(false);
  }

  let buttonRef = useRef();

  return React.createElement(UsersRender, {
    menuIsOpen,
    clickProfile,
    thisUser: props.user.authenticated ? props.user : {},
    handleClose,
    buttonRef
  });
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  user: state.user
}))(Users);
